import React, { useEffect, useRef } from "react";
import { FaceMesh } from "@mediapipe/face_mesh";
import { Camera } from "@mediapipe/camera_utils";

function FaceOverlay({ videoRef, selectedFilter }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!videoRef.current || !selectedFilter) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const faceMesh = new FaceMesh({
      locateFile: (file) =>
        `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`,
    });

    faceMesh.setOptions({
      maxNumFaces: 1,
      refineLandmarks: true,
      minDetectionConfidence: 0.5,
      minTrackingConfidence: 0.5,
    });

    faceMesh.onResults((results) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (
        results.multiFaceLandmarks &&
        results.multiFaceLandmarks.length > 0
      ) {
        const landmarks = results.multiFaceLandmarks[0];

        const leftEye = landmarks[33];
        const rightEye = landmarks[263];

        const x = ((leftEye.x + rightEye.x) / 2) * canvas.width;
        const y = ((leftEye.y + rightEye.y) / 2) * canvas.height;

        const img = new Image();
        img.src = selectedFilter.src;
        img.onload = () => {
          ctx.drawImage(img, x - 50, y - 30, 100, 60);
        };
      }
    });

    const camera = new Camera(videoRef.current, {
      onFrame: async () => {
        await faceMesh.send({ image: videoRef.current });
      },
      width: 320,
      height: 220,
    });

    camera.start();

    return () => {
      camera.stop();
    };
  }, [videoRef, selectedFilter]);

  return (
    <canvas
      ref={canvasRef}
      width="320"
      height="220"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 20,
        pointerEvents: "none",
      }}
    />
  );
}

export default FaceOverlay;
